const champion_coaches = [
    {
        name: 'Aatrox',
        coachesCount: 2,
        image: '/images/league-of-legends/champions/covers/Aatrox.jpg',
    },
    {
        name: 'Ahri',
        coachesCount: 6,
        image: '/images/league-of-legends/champions/covers/Ahri.jpg',
    },
    {
        name: 'Akali',
        coachesCount: 2,
        image: '/images/league-of-legends/champions/covers/Akali.jpg',
    },
    {
        name: 'Alistar',
        coachesCount: 2,
        image: '/images/league-of-legends/champions/covers/Alistar.jpg',
    },
    {
        name: 'Amumu',
        coachesCount: 2,
        image: '/images/league-of-legends/champions/covers/Amumu.jpg',
    },
    {
        name: 'Anivia',
        coachesCount: 2,
        image: '/images/league-of-legends/champions/covers/Anivia.jpg',
    },
    {
        name: 'Annie',
        coachesCount: 2,
        image: '/images/league-of-legends/champions/covers/Annie.jpg',
    },
    {
        name: 'Ashe',
        coachesCount: 2,
        image: '/images/league-of-legends/champions/covers/Ashe.jpg',
    },
    {
        name: 'Aurelion Sol',
        coachesCount: 2,
        image: '/images/league-of-legends/champions/covers/AurelionSol.jpg',
    },
    {
        name: 'Azir',
        coachesCount: 2,
        image: '/images/league-of-legends/champions/covers/Azir.jpg',
    },
    {
        name: 'Bard',
        coachesCount: 2,
        image: '/images/league-of-legends/champions/covers/Bard.jpg',
    },
    {
        name: 'Blitzcrank',
        coachesCount: 2,
        image: '/images/league-of-legends/champions/covers/Blitzcrank.jpg',
    },
    {
        name: 'Brand',
        coachesCount: 2,
        image: '/images/league-of-legends/champions/covers/Brand.jpg',
    },
    {
        name: 'Braum',
        coachesCount: 2,
        image: '/images/league-of-legends/champions/covers/Braum.jpg',
    },
    {
        name: 'Caitlyn',
        coachesCount: 2,
        image: '/images/league-of-legends/champions/covers/Caitlyn.jpg',
    },
    {
        name: 'Camille',
        coachesCount: 2,
        image: '/images/league-of-legends/champions/covers/Camille.jpg',
    },
    {
        name: 'Cassiopeia',
        coachesCount: 2,
        image: '/images/league-of-legends/champions/covers/Cassiopeia.jpg',
    },
    {
        name: "Cho'Gath",
        coachesCount: 2,
        image: '/images/league-of-legends/champions/covers/Chogath.jpg',
    },
    {
        name: 'Corki',
        coachesCount: 2,
        image: '/images/league-of-legends/champions/covers/Corki.jpg',
    },
    {
        name: 'Darius',
        coachesCount: 2,
        image: '/images/league-of-legends/champions/covers/Darius.jpg',
    },
    {
        name: 'Diana',
        coachesCount: 2,
        image: '/images/league-of-legends/champions/covers/Diana.jpg',
    },
    {
        name: 'Dr. Mundo',
        coachesCount: 2,
        image: '/images/league-of-legends/champions/covers/DrMundo.jpg',
    },
    {
        name: 'Draven',
        coachesCount: 2,
        image: '/images/league-of-legends/champions/covers/Draven.jpg',
    },
    // TODO: Add more champions
];

export default champion_coaches;